var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"basket-app"}},[_c('main',{staticClass:"basket-main"},[_c('b-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),(_vm.showCoockiePolicy)?_c('cookie-policy'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }